# GraphQL mutation to delete a email automation

mutation DeleteEmailAutomation($emailAutomation: DeleteEmailAutomationInputFieldInput!) {
    deleteEmailAutomation(input: {emailAutomation: $emailAutomation}) {
        emailAutomation {
            id
        }
    }
}
